export const getAddressLinesFromLocation = (location) => {
  const formattedAddress = location?.formattedAddress || location?.formatted_address || '';

  if (!location?.data)
    return { addressLine1: formattedAddress, addressLine2: '' };

  try {
    const parsed = JSON.parse(location.data);
    const get = (type) =>
      parsed?.address_components.find((c) => c.types.includes(type))
        ?.short_name || '';

    const locality = get('locality');
    const region = get('administrative_area_level_1');
    const postal = get('postal_code');
    const street = get('route');
    const streetNumber = get('street_number');
    const neighborhood = get('neighborhood');

    // Parse from HTML if possible; otherwise build manually.
    // eslint-disable-next-line no-undef
    let addressLine1 = new DOMParser()
      .parseFromString(parsed?.adr_address, 'text/html')
      .querySelector('.street-address')?.textContent;
    if (!addressLine1) {
      addressLine1 = [streetNumber, street].filter(Boolean).join(', ');
    }

    const localityLabel =
      neighborhood && formattedAddress.includes(neighborhood)
        ? neighborhood
        : locality;
    let addressLine2 = [localityLabel, region].filter(Boolean).join(', ');
    if (postal) {
      addressLine2 += ` ${postal}`;
    }

    // Final fallback if both lines are empty
    if (!addressLine1 && !addressLine2) {
      addressLine1 = formattedAddress;
    }

    return { addressLine1, addressLine2 };
  } catch (e) {
    return { addressLine1: formattedAddress, addressLine2: '' };
  }
};

export const handleLocationClick = (addressLines, location, isDesktop) => {
    const hasLocationData = addressLines.addressLine1 || location.map_url || location.formattedAddress;
    if (!hasLocationData) return;

    let searchQuery = '';

    if (addressLines.addressLine1) {
      searchQuery = addressLines.addressLine1;
      if (addressLines.addressLine2) {
        searchQuery += `, ${addressLines.addressLine2}`;
      }
    } else if (location.formattedAddress) {
      searchQuery = location.formattedAddress;
    }

    if (isDesktop) {
      const mapUrl = location.map_url ||
        `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchQuery)}`;
      window.open(mapUrl, '_blank');
    } else {
      const query = location.place_id || searchQuery;
      window.location.href = `maps://?q=${encodeURIComponent(query)}`;
    }
  };
